import { rem } from '@innovyze/stylovyze';
import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(${rem(300)}, 1fr));
	grid-gap: ${rem(40)};
`;

export const ButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
`;

export const IntegrationInfoContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: 30px auto auto auto;
	grid-gap: ${rem(10)};
	align-items: flex-start;
	align-content: flex-start;
`;

export const IntegrationInfoHeader = styled.div`
	display: grid;
	grid-template-columns: auto auto;
	grid-gap: ${rem(10)};
	justify-content: space-between;
	align-items: center;
`;
export const IntegrationInfoBody = styled.div``;
export const IntegrationInfoTable = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(${rem(10)}, 1fr));
	grid-gap: ${rem(4)};
`;
export const IntegrationInfoFooter = styled.div``;

export const ArcGisSettingsFooter = styled.div`
	display: grid;
	grid-template-columns: auto auto;
	grid-gap: 16px;
	justify-content: flex-end;
`;
